import {defineNuxtRouteMiddleware} from '#app';
import {navigateTo, useAuth} from '#imports';

export default defineNuxtRouteMiddleware((to) => {
    if (to.path === '/service-level' || to.path === '/service-level/') {
        const {getSelectedIdentity} = useAuth();

        return navigateTo(`/organization/${getSelectedIdentity!.organizationId}/service-level`, {external: false});
    }
});
